module.exports = __webpack_public_path__ + "static/media/webshop_splash_vehicles.1abb98a0.png";